<template>
  <div class="followed">
    <calendar
      :is-followed="true"
    />
  </div>
</template>

<script>
import Calendar from '@/components/Calendar/Calendar'

export default {
  name: 'Followed',
  components: {
    Calendar,
  },
  async created() {
  },
}
</script>

<style scoped lang="scss">
.followed{
  height: 100%;
}
</style>
